import { Document, Page, View, StyleSheet, Text, Font, Image, Link } from "@react-pdf/renderer";
import srcArial from "../../../assets/custom/font/arial/arial.ttf";
import srcArialBold from "../../../assets/custom/font/arial/ARIBL0.ttf";
import imgKkp from '../../../assets/images/logo-kkp.png'
import { useCallback, useEffect, useMemo, useState } from "react";
import KapalService from "../../../services/kapal/KapalService";
import imgCheck from "../../../assets/images/icons/check.png"
import { formatDateStringLocalDateINA } from "../../../utilities/Utils";

Font.register({ family: "Arial", src: srcArial });
Font.register({ family: "ArialBold", src: srcArialBold });

// Styles
const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 115,
        height: 115,
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial"
    },
    textcenter: {
        fontSize: 10,
        fontFamily: "Arial",
        textAlign: "center"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    },
    cell: {
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: '#000',
        padding: 4,
        minHeight: 24,
        textAlign: 'center',
        justifyContent: 'center',
    },
    checkicon: {
        width: 12,
        height: 12
    }
});


// Komponen PDF
const FormCetakAudit = ({ dataDisposisi, dataPpmKapal }) => {

    let kapalService = useMemo(() => new KapalService(), [])

    const [listDokAudit, setListDokAudit] = useState([])
    const [hasilAuditDok, setHasilAuditDok] = useState([])
    const [hasilAudit, setHasilAudit] = useState(null)
    const [masterKapal, setMasterKapal] = useState(null)

    const fetchAllData = useCallback(async () => {
        if (!dataPpmKapal?.nomorAjuKapal || !dataDisposisi?.noTugas) {
            console.log("data Kapal atau data disposisi kosong")
            return
        }

        try {
            const results = await Promise.allSettled([
                kapalService.listJenisDokKapal(null, 'aud', 0, 10),
                kapalService.listAuditKecukupan(dataPpmKapal.nomorAjuKapal),
                kapalService.getMasterKapalById(dataPpmKapal.idKapal)
            ])

            const [resRefDok, resHasilAudit, resMasterKapal] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;
            const hasilAudit = resHasilAudit.value?.data?.data?.[0]

            setListDokAudit(getData(resRefDok))
            setHasilAudit(hasilAudit)

            const resHasilAuditDOk = await kapalService.listAuditKecukupanDok(hasilAudit.idInspeksiAudit)
            setHasilAuditDok(resHasilAuditDOk.data.data)
            setMasterKapal(getData(resMasterKapal))

        } catch (error) {
            console.log(error)
        }

    }, [dataDisposisi, dataPpmKapal, kapalService])

    useEffect(() => {
        let isMounted = true;
        if (!dataPpmKapal) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataPpmKapal, fetchAllData]);

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {/* HEADER */}
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: 'solid' }]}>
                        <View style={[styles.tableCol, { width: '25%' }]}>
                            <Image style={styles.headingImg} src={imgKkp} />
                        </View>
                        <View style={[styles.tableCol, { width: '70%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#7895be' }]}>KEMENTERIAN KELAUTAN DAN PERIKANAN</Text>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#7895be' }]}>BADAN PENGENDALIAN DAN PENGAWASAN MUTU</Text>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: 'center', color: '#7895be' }]}>HASIL KELAUTAN DAN PERIKANAN</Text>
                            {/* <Text style={[styles.text, { fontSize: 14, textAlign: 'center', color: '#7895be' }]}>BALAI BESAR KARANTINA IKAN, PENGENDALIAN MUTU DAN KEAMANAN PERIKANAN JAKARTA I</Text> */}
                            <Text style={[styles.text, { textAlign: 'center' }]}>JL. MEDAN MERDEKA TIMUR NOMOR 16</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>JAKARTA 10110, KOTAK POS 4130 JKP 10041</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>TELEPON (021) 3519070 (LACAK), FAKSIMILE (021) 3513282</Text>
                            <Text style={[styles.text, { textAlign: 'center' }]}>
                                LAMAN{" "}
                                <Link
                                    src="https://www.kkp.go.id"
                                    style={{ color: "blue", textDecoration: "underline" }}
                                >
                                    www.kkp.go.id
                                </Link>
                            </Text>
                        </View>
                    </View>
                </View>

                <View style={[styles.table, { marginTop: 5 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { marginBottom: 8, width: '100%', alignItems: 'center' }]}>
                            <Text style={[styles.textBold, { fontSize: 12 }]}>AUDIT KECUKUPAN (Desk Audit)</Text>
                        </View>
                    </View>
                    <View style={[styles.table]}>
                        <View style={[styles.tableRow,]}>
                            <View style={[styles.tableCol, { width: "20%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    Nama Kapal
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "3%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    :
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "70%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    {dataPpmKapal && dataPpmKapal.namaKapal}
                                </Text>
                            </View>
                        </View>

                        <View style={[styles.tableRow,]}>
                            <View style={[styles.tableCol, { width: "20%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    Jenis Kapal
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "3%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    :
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "70%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    {dataPpmKapal && (dataPpmKapal.jenisKapal === "1" ? 'Penangkap' : 'Pembeku')}
                                </Text>
                            </View>
                        </View>

                        <View style={[styles.tableRow,]}>
                            <View style={[styles.tableCol, { width: "20%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    Ukuran Kapal
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "3%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    :
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "70%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    {dataPpmKapal && dataPpmKapal.ukuranKapal} GT
                                </Text>
                            </View>
                        </View>

                        <View style={[styles.tableRow,]}>
                            <View style={[styles.tableCol, { width: "20%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    Alamat
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "3%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    :
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "70%", alignItems: "left" }]}>
                                <Text style={[styles.text, { fontSize: 11, textAlign: "Left" }]}>
                                    {masterKapal && masterKapal.alamatPemilik}
                                </Text>
                            </View>
                        </View>

                        <View style={[styles.table, { marginTop: 15 }]}>
                            <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, backgroundColor: "#c0c0c0ff" }]}>
                                <View style={[styles.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "center", paddingTop: 9 }]}>
                                        NO.
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "45%", alignItems: "center", borderRightWidth: 1, }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "center", paddingTop: 9 }]}>
                                        KELENGKAPAN
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "20%", alignItems: "center", borderRightWidth: 1 }]}>
                                    <View style={[styles.tableRow]}>
                                        <View style={[styles.tableCol, { width: "100%", alignItems: "center" }]}>
                                            <Text style={[styles.text, { fontSize: 11, textAlign: "center" }]}>
                                                KETERSEDIAAN
                                            </Text>
                                        </View>
                                    </View>
                                    <View style={[styles.tableRow]}>
                                        <View style={[styles.tableCol, { width: "50%", alignItems: "center", borderTopWidth: 1, borderRightWidth: 1, }]}>
                                            <Text style={[styles.text, { fontSize: 11, textAlign: "center" }]}>
                                                ADA
                                            </Text>
                                        </View>
                                        <View style={[styles.tableCol, { width: "50%", alignItems: "center", borderTopWidth: 1, }]}>
                                            <Text style={[styles.text, { fontSize: 11, textAlign: "center" }]}>
                                                TIDAK
                                            </Text>
                                        </View>
                                    </View>
                                </View>
                                <View style={[styles.tableCol, { width: "30%", alignItems: "center", borderRightWidth: 1, }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "center", paddingTop: 9 }]}>
                                        KETERANGAN
                                    </Text>
                                </View>
                            </View>

                            <View style={[styles.tableRow, { borderLeftWidth: 1, borderTopWidth: 1, backgroundColor: "#c0c0c0ff" }]}>
                                <View style={[styles.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.textBold, { fontSize: 11, textAlign: "center", }]}>
                                        A.
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "95%", alignItems: "left", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.textBold, { fontSize: 11, textAlign: "left", paddingLeft: 5 }]}>
                                        DOKUMEN PENUNJANG INSPEKSI
                                    </Text>
                                </View>
                            </View>
                            {
                                listDokAudit && listDokAudit.map((dokwajib, idx) => {
                                    const current = hasilAuditDok.find((h) => h.idJenisDok === dokwajib.id)

                                    return (
                                        <View key={idx} style={[styles.tableRow, { borderLeftWidth: 1, }]}>
                                            <View style={[styles.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                                <Text style={[styles.text, { fontSize: 11, textAlign: "center", }]}>
                                                    {idx + 1}
                                                </Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "45%", alignItems: "left", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                                <Text style={[styles.text, { fontSize: 11, textAlign: "left", paddingLeft: 5 }]}>
                                                    {/* <JenisDokumenKapal id={dokwajib.idJenisDok} /> */}
                                                    {dokwajib.jenisDokKapal}
                                                </Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "10%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                                <Text style={[styles.text, { fontSize: 11, textAlign: "center", }]}>
                                                    {current?.isTersedia === "1" && <Image src={imgCheck} style={styles.checkicon} />}
                                                </Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "10%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                                <Text style={[styles.text, { fontSize: 11, textAlign: "center", }]}>
                                                    {current?.isTersedia === "0" && <Image src={imgCheck} style={styles.checkicon} />}
                                                </Text>
                                            </View>
                                            <View style={[styles.tableCol, { width: "30%", alignItems: "left", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                                <Text style={[styles.text, { fontSize: 11, textAlign: "left", }]}>
                                                    {current?.keterangan}
                                                </Text>
                                            </View>
                                        </View>
                                    )
                                })
                            }

                            <View style={[styles.tableRow, { borderLeftWidth: 1, backgroundColor: "#c0c0c0ff" }]}>
                                <View style={[styles.tableCol, { width: "5%", alignItems: "center", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.textBold, { fontSize: 11, textAlign: "center", }]}>
                                        B.
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "95%", alignItems: "left", borderRightWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.textBold, { fontSize: 11, textAlign: "left", paddingLeft: 5 }]}>
                                        CATATAN
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow, { borderLeftWidth: 1, }]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left", borderRightWidth: 1, borderBottomWidth: 1, minHeight: 50 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "left", padding: 5 }]}>
                                        {hasilAudit && hasilAudit.catatan}
                                    </Text>
                                </View>
                            </View>

                            <View style={[styles.tableRow,]}>
                                <View style={[styles.tableCol, { width: "100%", alignItems: "left", }]}>
                                    <Text style={[styles.text, { fontSize: 9, textAlign: "left", }]}>
                                        *Jika ada
                                    </Text>
                                </View>
                            </View>
                        </View>


                        <View style={[styles.table, { marginTop: 15 }]}>
                            <View style={[styles.tableRow,]}>
                                <View style={[styles.tableCol, { width: "37%", alignItems: "center", borderRightWidth: 1, }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "center", }]}>

                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "30%", alignItems: "left", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "left", paddingLeft: 5 }]}>
                                        Inspektur Mutu
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "3%", alignItems: "center", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "center", }]}>
                                        :
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "30%", alignItems: "left", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 10, textAlign: "left", paddingLeft: 5 }]}>
                                        {hasilAudit && hasilAudit.nmPetugas}
                                    </Text>
                                </View>
                            </View>

                            <View style={[styles.tableRow,]}>
                                <View style={[styles.tableCol, { width: "37%", alignItems: "center", borderRightWidth: 1, }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "center", }]}>

                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "30%", alignItems: "left", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "left", paddingLeft: 5 }]}>
                                        No. Reg
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "3%", alignItems: "center", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "center", }]}>
                                        :
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "30%", alignItems: "left", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "left", paddingLeft: 5 }]}>
                                        {hasilAudit && hasilAudit.noregPetugas}
                                    </Text>
                                </View>
                            </View>

                            <View style={[styles.tableRow,]}>
                                <View style={[styles.tableCol, { width: "37%", alignItems: "center", borderRightWidth: 1, }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "center", }]}>

                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "30%", alignItems: "left", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "left", paddingLeft: 5 }]}>
                                        Tanggal Audit Kecukupan
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "3%", alignItems: "center", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "center", }]}>
                                        :
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "30%", alignItems: "left", borderRightWidth: 1, borderTopWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "left", paddingLeft: 5 }]}>
                                        {hasilAudit && formatDateStringLocalDateINA(hasilAudit.tglAudit)}
                                    </Text>
                                </View>
                            </View>
                            <View style={[styles.tableRow,]}>
                                <View style={[styles.tableCol, { width: "37%", alignItems: "center", borderRightWidth: 1, }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "center", }]}>

                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "30%", alignItems: "left", borderRightWidth: 1, borderTopWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "left", paddingLeft: 5 }]}>
                                        Tanda Tangan
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "3%", alignItems: "center", borderRightWidth: 1, borderTopWidth: 1, borderBottomWidth: 1 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "center", }]}>
                                        :
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "30%", alignItems: "left", borderRightWidth: 1, borderTopWidth: 1, borderBottomWidth: 1, minHeight: 40 }]}>
                                    <Text style={[styles.text, { fontSize: 11, textAlign: "left", }]}>

                                    </Text>
                                </View>
                            </View>
                        </View>

                    </View>
                </View>
            </Page>
        </Document>
    )
}

export default FormCetakAudit;